<template>
  <aside v-if="headings.length > 0" class="article-toc">
    <div class="article-toc__header">
      <h6>In this article</h6>
    </div>
    
    <nav class="article-toc__nav">
      <ul class="article-toc__list">
        <li 
          v-for="(heading, index) in headings" 
          :key="index"
          class="article-toc__item"
          :class="`article-toc__item--level-${heading.level}`"
        >
          <a 
            :href="`#${heading.id}`"
            class="article-toc__link"
            :class="{ 'article-toc__link--active': activeHeading === heading.id }"
            @click.prevent="scrollToHeading(heading.id)"
          >
            {{ heading.text }}
          </a>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
export default {
  name: "ArticleTableOfContents",
  props: {
    articleHtml: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headings: [],
      activeHeading: null,
    };
  },
  watch: {
    articleHtml: {
      immediate: true,
      handler(newVal) {
        console.log('Article HTML changed, length:', newVal ? newVal.length : 0);
        // Wait longer for v-html to render the content
        setTimeout(() => {
          this.extractHeadings();
          this.setupScrollSpy();
        }, 500);
      },
    },
  },
  mounted() {
    // Listen to scroll on the content container, not window
    const scrollContainer = document.querySelector('.support-content');
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', this.onScroll);
    }
    // Also try to extract on mount in case content is already there
    setTimeout(() => {
      this.extractHeadings();
    }, 500);
  },
  beforeUnmount() {
    const scrollContainer = document.querySelector('.support-content');
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', this.onScroll);
    }
  },
  methods: {
    extractHeadings() {
      this.headings = [];
      
      const content = document.querySelector('.support-article__content');
      
      if (!content) {
        // Retry after a delay if content isn't ready yet
        setTimeout(() => {
          this.extractHeadings();
        }, 500);
        return;
      }

      // Extract h2 and h3 headings from the article
      const headingElements = content.querySelectorAll('h2, h3');
      
      headingElements.forEach((heading, index) => {
        // Create an ID if it doesn't have one
        if (!heading.id) {
          heading.id = `heading-${index}`;
        }

        this.headings.push({
          id: heading.id,
          text: heading.textContent.trim(),
          level: parseInt(heading.tagName.substring(1)), // h2 -> 2, h3 -> 3
        });
      });
    },
    scrollToHeading(id) {
      const element = document.getElementById(id);
      const scrollContainer = document.querySelector('.support-content');
      
      if (element && scrollContainer) {
        const offset = 20; // Offset from top of container
        const elementPosition = element.offsetTop;
        
        // Calculate the position to scroll to within the container
        const scrollTo = elementPosition - offset;

        scrollContainer.scrollTo({
          top: scrollTo,
          behavior: 'smooth',
        });

        history.replaceState(null, '', `#${id}`);
        this.activeHeading = id;
      }
    },
    onScroll() {
      const scrollContainer = document.querySelector('.support-content');
      if (!scrollContainer) return;
      
      const scrollPosition = scrollContainer.scrollTop + 100;

      // Find the active heading based on scroll position within the container
      for (let i = this.headings.length - 1; i >= 0; i--) {
        const heading = this.headings[i];
        const element = document.getElementById(heading.id);
        
        if (element && element.offsetTop <= scrollPosition) {
          this.activeHeading = heading.id;
          break;
        }
      }
    },
    setupScrollSpy() {
      // Initialize active heading on mount
      this.onScroll();
    },
  },
};
</script>

